import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '../base/controls';

interface Props {
    color: '#f1f4f9' | 'white';
    onTryDispatcherButton: () => void;
}

const TryDispatcher = (props: Props) => {
    const { t } = useTranslation();

    return (
        <Row align={'middle'} className="rl-try-dispatcher" style={{ background: props.color }}>
            <Col span={14}>
                <b className="rl-try-dispatcher-text">{t('TryDispatcher.text')}</b>
            </Col>
            <Col span={10} style={{ textAlign: 'end' }}>
                <Button type="secondary" className="rl-try-dispatcher-button" onClick={props.onTryDispatcherButton}>
                    {t('NavBar.tryDispatcher')}
                </Button>
            </Col>
        </Row>
    );
};

export default TryDispatcher;
